<template>
  <div class="flex flex-wrap items-center gap-2">
    <input
      data-test="preview-link-value"
      class="min-w-0 flex-1 rounded-sm border border-divider p-2 text-sm text-gray-700"
      :value="link"
      readonly
      @focus="$event.target.select()"
    />
    <a
      data-test="preview-link"
      class="rounded-sm px-3 py-2 text-sm font-medium text-hqPurple outline-solid outline-1 -outline-offset-1 outline-hqPurple100"
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
    >
      Open
    </a>
    <Button secondaryButton data-test="Copy" text="Copy" @click="copyLink(link)" />
    <p v-if="expiresLabel" data-test="preview-link-expiry" class="w-full text-sm text-gray-500">
      {{ expiresLabel }}
    </p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { format, isValid, parseISO } from "date-fns";
import Button from "@/components/UI/Form/Button/Button.vue";
import { useCopyLink } from "@/hooks/useCopyLink";

const props = defineProps({
  link: {
    type: String,
    required: true,
  },
  // ISO timestamp from the share endpoints; shown in the viewer's own time zone.
  expiresAt: {
    type: String,
    default: "",
  },
});

const expiresLabel = computed(() => {
  const date = props.expiresAt ? parseISO(props.expiresAt) : null;
  return date && isValid(date) ? `Valid until ${format(date, "MMM d, HH:mm")}` : "";
});

const { copyLink } = useCopyLink();
</script>
